import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { FullPriceContainerBlockLarge, MicroCopy, StartsAtMicroCopy } from 'pricing-pages-ui-components/price/PriceStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PriceDisplayBreeze = ({
  pricingInfo,
  includedUnits,
  seleniumId,
  currencyCode,
  currencyCodeUnit
}) => {
  const {
    monthly: {
      calculatedPrice: monthlyCalculatedPrice
    }
  } = pricingInfo;
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    children: [StartsAtMicroCopy, /*#__PURE__*/_jsx(FullPriceContainerBlockLarge, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: monthlyCalculatedPrice,
        showPricePerMonthPerSeat: false,
        seleniumId: seleniumId,
        currencyCode: currencyCode,
        currencyCodeUnit: currencyCodeUnit
      })
    }), /*#__PURE__*/_jsxs(MicroCopy, {
      use: "help",
      "data-test-id": "payment-terms",
      children: [/*#__PURE__*/_jsx(PriceDisplay, {
        price: includedUnits ? monthlyCalculatedPrice / includedUnits : 0,
        currencyCode: currencyCode,
        round: false,
        currencyCodeUnit: currencyCodeUnit
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "priceDisplay.highlightedPrice.terms.breezeSubtext"
      })]
    })]
  });
};